export const createTwitterProfileURL = (username: string) => {
  return `https://twitter.com/${username}`;
};
